import { GoalType } from '@griply/types';
import { countGoalsTowardLimit } from '@griply/utils';
import { useMemo } from 'react';
import { useEntityLinks } from 'shared/hooks/use-entity-links';
import { usePremiumFeatureAllowed } from 'shared/hooks/use-premium-feature-allowed';
import { LimitKeys } from 'shared/types/limit-keys';

import { useGoals } from './use-goals';

export const useCreateUnlimitedGoalsAllowed = (
  goalType: GoalType = GoalType.Goal,
) => {
  const goals = useGoals();
  const links = useEntityLinks();
  const limitKey =
    goalType === GoalType.Project
      ? LimitKeys.CreateProject
      : LimitKeys.CreateGoal;

  const total = useMemo(
    () => countGoalsTowardLimit(goals, limitKey, links),
    [goals, limitKey, links],
  );

  const { allowed, enforced, limit } = usePremiumFeatureAllowed(limitKey, {
    totalUncompleted: total,
  });

  return { allowed, limit, enforced, total };
};
